














import { Component, Vue, Prop } from 'vue-property-decorator'
import { Room } from '@/class/room'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    BtnSquare,
    HeadlineBorder
  }
})
export default class RoomMemberList extends Vue {
  @Prop() room!: Room;
  @Prop() memberId!: string;

  get isRoomMaster () {
    return this.room.masterId === this.memberId
  }

  setRoomMaster (memberId: string) {
    if (!this.isRoomMaster) { return }
    this.room.updateRoomMaster(memberId)
  }

  get roomMembers () {
    return this.room.members
  }

  removePlayer (id: string) {
    this.room.removeRoomMember(id)
  }
}
